module.exports = __webpack_public_path__ + "img/septeo.ad532fa5.png";